import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ReplenishmentTaskDetailPageRBAC = {
  pageID: '80d164cd0be340ecc4fcc6af8d0757c9',
  elementID: {
    TableList: 'faf3cc6b15feadacb969f76e8d7799fb',
    BtnPrintSlipTask: '2a523edac7eac92eb5d0ef0f230124cd',
    BtnPartialReplenishment: '290b8bebef1a7ce7c15bcc1fc84bb2fc',
    BtnFinishReplenish: '17319bf78d52c8b1777eca0d15161e08',
    BtnAssignIC: 'ed63869dfa13a2084284fea309cfd5d0',
    BtnStartReplenish: '43f34a0c23297df2f7e767f0f36671e5',
    BtnCancelReplenish: '0740fdcb72ba6a75a0818c2bd6ed4109',
  },
} as const

export const useRBACReplenishmentTaskDetailPage = createUseRBAC(
  ReplenishmentTaskDetailPageRBAC.elementID,
)

export type UseRBACReplenishmentTaskDetailPageType = ReturnType<
  typeof useRBACReplenishmentTaskDetailPage
>
